import { render, staticRenderFns } from "./reem.vue?vue&type=template&id=cbedfe0c&"
import script from "./reem.vue?vue&type=script&lang=js&"
export * from "./reem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports